module.exports = __webpack_public_path__ + "img/fdsu-docs.85ee1cae.png";